import React, { useState } from 'react';
import { Link as RouterLink } from "react-router-dom";
import {
  Grid,
  Typography,
  TextField,
  Box,
  IconButton,
  InputAdornment,
  Link
} from "@mui/material";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import Button from "../../components/Button";
import { useNavigate } from "react-router-dom";
import UserService from '../../components/service/UserService';

const Login = ({ handleLogin }) => {
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [data, setData] = useState({
    email: "",
    password: "",
  });
  const navigate = useNavigate();

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleChange = (event) => {
    setErrorMessage('');
    const name = event.target.name;
    const value = event.target.value;
    setData((values) => ({ ...values, [name]: value }));
  };

  const login = async (event) => {
    event.preventDefault();
    const { email, password } = data;

    try {
      console.log('Logging in with:', { email, password });
      const userData = await UserService.login(email, password);
      console.log('User data:', userData);

      if (userData.token) {
        localStorage.setItem('token', userData.token);
        localStorage.setItem('role', userData.role);
        localStorage.setItem('login', 'true'); // Add this for JobPage check
        handleLogin(true);
        navigate('/Job'); // FIXED: Changed from '/dashboard' to '/Job'
      } else {
        setErrorMessage(userData.message || 'Invalid email or password');
      }
    } catch (error) {
      console.error("Error during login:", error);
      setErrorMessage(error.response ? error.response.data.message : 'An error occurred while logging in');
    }
  };

  const handleClick = () => {
    navigate('/signup');
  };

  return (
    <Box className='signup_container'
      sx={{
        boxShadow: "0px 1px 6px #00000015",
        borderRadius: '9px',
        padding: '6%',
        width: '60%',
        marginTop: '13%',
        background: "#FFFFFF",
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Typography sx={{ color: '#000000', letterSpacing: '0.22px', fontWeight: '600', fontSize: '36px', fontFamily: 'Rubik' }} component="h1" variant="h5">
        Log In
      </Typography>
      <Typography sx={{ color: '#888888', letterSpacing: '0.09px', fontFamily: 'Rubik' }} component="h1">
        Log In to your account
      </Typography>
      <Box component="form" noValidate sx={{ mt: 3 }} onSubmit={login}>
        <label htmlFor="email" style={{ color: '#000000', fontWeight: 'normal', fontSize: '14px' }}>
          Email ID
        </label>
        <TextField
          required
          fullWidth
          id="email"
          value={data.email}
          onChange={handleChange}
          placeholder='Enter your email ID here'
          style={{ fontFamily: 'Rubik', marginTop: '4px', fontWeight: 'normal', paddingBottom: '8%' }}
          name="email"
          autoComplete="email"
          autoFocus
        />
        <label htmlFor="password" style={{ fontFamily: 'Rubik', color: '#000000', fontWeight: 'normal', fontSize: '14px' }}>
          Password
        </label>
        <TextField
          required
          placeholder='Enter your password'
          fullWidth
          id="password"
          value={data.password}
          onChange={handleChange}
          style={{ fontFamily: 'Rubik', fontWeight: 'normal', marginTop: '4px', paddingBottom: '13px' }}
          name="password"
          type={showPassword ? 'text' : 'password'}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  edge="end"
                  style={{ color: '#0D5C75' }}
                >
                  {showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            )
          }}
        />
        <Grid style={{ display: 'flex', flexDirection: 'column', marginTop: '7%' }}>
          <Typography style={{ marginLeft: '34%', color: 'red', fontSize: '13px' }}>{errorMessage}</Typography>
          <Grid style={{ display: 'flex', justifyContent: 'center', marginTop: '1%' }}>
            <Button
              color="primary"
              name="Log In"
              type="submit"
              onClick={login}
            />
          </Grid>
        </Grid>
        <Grid style={{ marginLeft: '26%', marginTop: '11%', display: 'flex', }}>
          <RouterLink
            to="/signup"
            style={{ color: '#0D5C75', fontSize: '18px', fontFamily: 'Rubik', fontWeight: 'bold', textDecoration: 'underline 1px solid #0D5C75' }}
          >
            Click here
          </RouterLink>
          <Typography style={{ marginLeft: '8px', fontFamily: 'Rubik' }}>
            to Sign Up
          </Typography>
        </Grid>
      </Box>
    </Box>
  );
}

export default Login;